import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=4584c484&scoped=true&"
import script from "./DashboardView.vue?vue&type=script&lang=js&"
export * from "./DashboardView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=4584c484&lang=scss&scoped=true&"
import style1 from "./DashboardView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4584c484",
  null
  
)

export default component.exports